import { cx } from "../../Util/classHelpers";
import TableV2 from "../TableV2/tableV2";
import styles from "./users-and-roles.module.css";
import { Permissions } from "../../Model/userObjects";
import SettingsIcon from "../Icons/settings-icon";
import Tooltip from "../CommonComponents/tooltip/Tooltip";

const columnConfig = [
  {
    id: "name",
    label: "Role",
    data: ({role}) => (
      <div className={styles.usersTableEntry}>{role.getName()}</div>
    ),
    headerClass: styles.usersTableHeader,
  },
  {
    id: "userCount",
    label: "Users",
    data: ({userCount}) => <div className={styles.usersTableEntry}>{userCount}</div>,
    headerClass: styles.usersTableHeader,
  },
  {
    id: "permissions",
    label: "Permissions",
    data: ({role}) => (
      <div className={styles.usersTableEntry}>
        {role.getPermissions().getActivePermissions().length} of {Permissions.allPermissions().length} enabled
      </div>
    ),
    headerClass: styles.usersTableHeader,
    tableClass: styles.entryFixedWidth,
  },
  {
    id: "actions",
    label: "",
    data: ({role, edit}) => <div className={styles.actionsTableEntry}>
      <Tooltip 
        content={role.isSystemRole() ? "The permissions of system provided roles can't be changed" : null}
        position="left"
      >
        <div 
          className={styles.settingsWrapper} 
          data-disabled={role.isSystemRole()}
          onClick={role.isSystemRole() ? () => {} : edit}
        >
          <SettingsIcon fill={role.isSystemRole() ? "#A3A3A3" : "#525252"} />
        </div>
      </Tooltip>
    </div>,
    headerClass: styles.usersTableHeader,
    tableClass: styles.settingsTd,
  }
];
  
const tableConfig = {
  columns: columnConfig,
  pagination: false,
  scrollable: true,
  hoverable: false,
};

const RolesTable = ({data}) => {
  return (
    <div className={cx(styles.usersTable, "table--no-td-padding", "table--no-last-separator")}>
        <TableV2 data={data} config={tableConfig} emptyText="No roles found" />
    </div>
  )
}
export default RolesTable
